const ListingDateSliderHook = {
  mounted() {
    this.page = 0;
    this.pageSize = 5;

    // Item size with gap in rems.
    // 5.4rem + 0.5rem gap
    this.itemSizeWithGap = 4.6 + 0.5;

    this.prevButton = document.querySelector(this.el.dataset.prevButton);
    this.nextButton = document.querySelector(this.el.dataset.nextButton);

    this.prevButton.addEventListener('click', () => {
      this.page = this.page - 1;
      this.updateStyle();
      this.toggleButtons();
    });

    this.nextButton.addEventListener('click', () => {
      this.page = this.page + 1;
      this.updateStyle();
      this.toggleButtons();
    });
  },

  updated() {
    this.updateStyle();
    this.toggleButtons();
  },

  updateStyle() {
    this.el.style.transform = `translateX(${
      this.page * this.pageSize * this.itemSizeWithGap * -1
    }rem)`;
  },

  toggleButtons() {
    if (this.page == 0) {
      this.prevButton.dataset.disabled = true;
    } else {
      delete this.prevButton.dataset.disabled;
    }

    if (this.page == 2) {
      this.nextButton.dataset.disabled = true;
    } else {
      delete this.nextButton.dataset.disabled;
    }
  },
};

export default ListingDateSliderHook;
